export default {
  TEST_IDS: {
    POPUP: 'popup'
  }
}